<template>
  <div ref="target" class="news-sort">
    <div class="left">
      <i></i>
      <RouterLink target="_blank" to="/video?firstCate=180"
        >卫生正高级职称</RouterLink
      >
    </div>
    <div class="right">
      <RouterLink target="_blank" to="/video?firstCate=180">
        <span>更多</span>
        <el-icon><ArrowRight /></el-icon>
      </RouterLink>
    </div>
  </div>
  <div class="news-tabs">
    <ShTabs v-model="activeName">
      <ShTabsPanel label="临床医学类" name="linchuangyixue">
        <GaoJiLinChuang
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="临床口腔类" name="linchuangkouqiang">
        <GaoJiKouQiang
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="医学中医类" name="linchuangzhongyi">
        <GaoJiZhongYi
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="临医检验类" name="linyijianyan">
        <GaoJiJianYan
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="护理学类" name="hulixue">
        <GaoJiHuLi
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="临医检验技术" name="jianyanjishu">
        <GaoJiJianYanJiShu
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="药学类" name="yaoxuelei">
        <GaoJiYaoXue
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="其他技术类" name="qitajishu">
        <GaoJiYiXueJiShu
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
    </ShTabs>
  </div>
</template>

<script>
import { findNewsBanner, findZhengGaoNews } from "@/api/news";
import { useLazyNews, useLazyNewsBanner } from "@/hooks";
import GaoJiZhongYi from "../compontents/zhenggaoji/zhenggaozhongyi-news.vue";
import GaoJiLinChuang from "../compontents/zhenggaoji/zhenggaolinchuang-news.vue";
import GaoJiKouQiang from "../compontents/zhenggaoji/zhenggaokouqiang-news.vue";
import GaoJiYiXueJiShu from "../compontents/zhenggaoji/zhenggaoyixuejishu-news.vue";
import GaoJiYaoXue from "../compontents/zhenggaoji/zhenggaoyaoxue-news.vue";
import GaoJiJianYanJiShu from "../compontents/zhenggaoji/zhenggaojianyanjishu-news.vue";
import GaoJiJianYan from "../compontents/zhenggaoji/zhenggaojianyan-news.vue";
import GaoJiHuLi from "../compontents/zhenggaoji/zhenggaohuli-news.vue";
import { ref } from "vue";
export default {
  name: "GaoJiNewsList",
  components: {
    GaoJiZhongYi,
    GaoJiLinChuang,
    GaoJiKouQiang,
    GaoJiYiXueJiShu,
    GaoJiYaoXue,
    GaoJiJianYanJiShu,
    GaoJiJianYan,
    GaoJiHuLi,
  },
  setup() {
    const activeName = ref("linchuangyixue");
    const target = ref(null);
    const { notice, policy } = useLazyNews(target, () =>
      findZhengGaoNews({ chID: 180 })
    );
    const { bannerList } = useLazyNewsBanner(target, () =>
      findNewsBanner({ chID: [180] })
    );
    return {
      activeName,
      target,
      bannerList,
      noticeList: notice,
      policyList: policy,
    };
  },
};
</script>

<style lang="less" scoped>
.news-sort {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  background: rgb(244, 244, 244);

  .left {
    i {
      display: inline-block;
      width: 3px;
      height: 20px;
      background: @shColor;
      margin-right: 15px;
    }
    a {
      font-size: 22px;
      &:hover {
        color: @shColor;
      }
    }
  }
  .right {
    margin-right: 10px;
    :hover {
      color: @shColor;
    }
    a {
      display: flex;
      align-items: center;
      color: #999;
    }
  }
}
.news-tabs {
  .news-list {
    height: 500px;
    //background: #f0e5e5;
    display: flex;
    justify-content: space-between;
    .left {
      width: 400px;
      height: 500px;
      display: flex;
      flex-direction: column;
      .top {
        width: 400px;
        height: 240px;
        .top-carousel {
          display: inline-block;
          width: 360px;
          height: 130px;
          margin-left: 20px;
          margin-right: 20px;
          margin-top: 15px;
          border-radius: 5px;
          a {
            img {
              border-radius: 5px;
            }
          }
          .bottom-carousel {
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            height: 80px;
            width: 360px;

            .carousel-top {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 40px;
              width: 360px;
            }
            .carousel-bottom {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 40px;
              width: 360px;
            }
          }
        }
      }

      .bottom {
        width: 400px;
        height: 250px;
        .recommend {
          display: flex;
          height: 50px;
          align-items: center;
          justify-content: space-between;
          background: rgb(244, 244, 244);
          h3 {
            margin-left: 10px;
          }
          .more {
            a {
              display: flex;
              align-items: center;
              margin-right: 10px;
              color: #999;
              &:hover {
                color: @shColor;
              }
            }
          }
        }
        .recommend-cate {
          display: flex;
          height: 210px;
          justify-content: space-between;
          .cate-left {
            width: 195px;
            position: relative;
            border: 1px solid rgb(244, 244, 244);
            a {
              width: 195px;
              margin-right: 5px;

              img {
                width: 195px;
                height: 120px;
              }
              i {
                display: inline-block;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 38px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 12px;
                background: @shColor;
              }
              span {
                margin: 5px 5px 5px 5px;
                &:hover {
                  color: @shColor;
                }
              }
            }
            .cate-desc {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              h3 {
                width: 80px;
                margin-left: 10px;
                color: #fd7502;
              }
              a {
                display: inline-block;
                height: 22px;
                margin-bottom: 5px;
                width: 80px;
              }
            }
          }
          .cate-right {
            width: 195px;
            position: relative;
            border: 1px solid rgb(244, 244, 244);
            a {
              width: 195px;
              margin-right: 5px;

              img {
                width: 195px;
                height: 120px;
              }
              i {
                display: inline-block;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 38px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 12px;
                background: @shColor;
              }
              span {
                margin: 5px 5px 5px 5px;
                &:hover {
                  color: @shColor;
                }
              }
            }
            .cate-desc {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              h3 {
                width: 80px;
                margin-left: 10px;
                color: #fd7502;
              }
              a {
                display: inline-block;
                width: 80px;
              }
            }
          }
        }
      }
    }
    .middle {
      margin-top: 15px;
      width: 400px;
      overflow: hidden;
      border: 1px solid rgb(244, 244, 244);
      .policy {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        background: rgb(244, 244, 244);
        div {
          display: flex;
          align-items: center;
          i {
            display: inline-block;
            width: 3px;
            height: 20px;
            background: @shColor;
          }
          h3 {
            margin-left: 10px;
          }
        }
        a {
          display: flex;
          align-items: center;
          color: #999;
          &:hover {
            color: @shColor;
          }
        }
      }
      .policy-news {
        ul {
          width: 390px;
          padding-top: 10px;
          padding-bottom: 10px;
          margin-left: 10px;
          & :hover {
            color: @shColor;
          }
          a {
            width: 390px;
            display: inline-block;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
    .right {
      margin-top: 15px;
      width: 400px;

      .notice {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        overflow: hidden;
        border: 1px solid rgb(244, 244, 244);
        background: rgb(244, 244, 244);
        div {
          display: flex;
          align-items: center;
          i {
            display: inline-block;
            width: 3px;
            height: 20px;
            background: @shColor;
          }
          h3 {
            margin-left: 10px;
          }
        }
        a {
          display: flex;
          align-items: center;
          color: #999;
          &:hover {
            color: @shColor;
          }
        }
      }
      .notice-news {
        height: 185px;
        padding-top: 5px;
        ul {
          width: 400px;
          padding-top: 5px;
          padding-bottom: 5px;
          margin-left: 10px;
          & :hover {
            color: @shColor;
          }
          a {
            display: inline-block;
            width: 400px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
      .notes {
        .notice {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 50px;
          background: rgb(244, 244, 244);
          div {
            display: flex;
            align-items: center;
            i {
              display: inline-block;
              width: 3px;
              height: 20px;
              background: @shColor;
            }
            h3 {
              margin-left: 10px;
            }
          }
          a {
            display: flex;
            align-items: center;
            color: #999;
            &:hover {
              color: @shColor;
            }
          }
        }
        .data-recomend {
          display: flex;
          justify-content: space-between;
          height: 210px;
          .cate-left {
            width: 195px;

            position: relative;
            border: 1px solid rgb(244, 244, 244);
            a {
              width: 195px;
              margin-right: 5px;

              img {
                width: 195px;
                height: 120px;
              }
              i {
                display: inline-block;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 38px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 12px;
                background: @shColor;
              }
              span {
                margin: 5px 5px 5px 5px;
                &:hover {
                  color: @shColor;
                }
              }
            }
            .cate-desc {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              h3 {
                width: 80px;
                margin-left: 10px;
                color: #fd7502;
              }
              a {
                display: inline-block;
                height: 22px;
                margin-bottom: 5px;
                width: 80px;
              }
            }
          }
          .cate-right {
            width: 195px;
            position: relative;
            border: 1px solid rgb(244, 244, 244);
            a {
              width: 195px;
              margin-right: 5px;

              img {
                width: 195px;
                height: 120px;
              }
              i {
                display: inline-block;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 38px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 12px;
                background: @shColor;
              }
              span {
                margin: 5px 5px 5px 5px;
                &:hover {
                  color: @shColor;
                }
              }
            }
            .cate-desc {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              h3 {
                width: 80px;
                margin-left: 10px;
                color: #fd7502;
              }
              a {
                display: inline-block;
                width: 80px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
